module.exports = __webpack_public_path__ + "static/media/peterchaianov.f9020aba.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/peterchaianov.webp
// module id = 757
// module chunks = 0